import { cn } from '@/lib/utils';
import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
type Props = {
  children: React.ReactNode;
  className?: string;
  href?: string;
  size?: 'md' | 'lg';
};
export function CTAButton({
  children,
  className = '',
  href = 'https://megapack-agenda-llena.impultienda.ar/checkout',
  size = 'lg'
}: Props) {
  const pad = size === 'lg' ? 'px-8 py-4 text-base sm:text-lg' : 'px-6 py-3 text-sm sm:text-base';
  return <a href={href} className={cn(`group inline-flex items-center justify-center gap-2 rounded-full bg-rose font-extrabold uppercase tracking-wide text-white shadow-[0_10px_40px_-8px_rgba(215,109,138,0.6)] ring-1 ring-rose-soft/40 transition-all duration-200 hover:-translate-y-0.5 hover:bg-rose-deep hover:shadow-[0_16px_50px_-8px_rgba(215,109,138,0.7)] focus:outline-none focus-visible:ring-2 focus-visible:ring-rose-soft ${pad} ${className}`, "pt-[3px] pb-[3px] mt-[-10px] mb-[-10px]", "text-[#F1EBEB]", "pt-[12px] pb-[12px]")} data-id="element-49" data-mp="2txjmidk9bxa9">
      {children}
      <ArrowRightIcon className="h-5 w-5 transition-transform duration-200 group-hover:translate-x-1" data-id="element-50" data-mp="199emqmn14qkf" />
    </a>;
}